type NavigatorWithUserAgentData = Navigator & {
  userAgentData?: {
    mobile?: boolean
    platform?: string
  }
}

const PHONE_OR_TABLET_PATTERN =
  /Android|iPhone|iPad|iPod|Mobile|Tablet|Tablet PC|Kindle|Silk|PlayBook|Windows Phone/i

export function isPhoneOrTabletDevice(
  navigatorValue?: NavigatorWithUserAgentData,
  hasCoarsePointer = false
): boolean {
  if (!navigatorValue) return false

  const userAgent = navigatorValue.userAgent || ''
  const userAgentDataPlatform = navigatorValue.userAgentData?.platform || ''
  const platform = navigatorValue.platform || ''
  const hasTouch = navigatorValue.maxTouchPoints > 0

  if (
    navigatorValue.userAgentData?.mobile ||
    PHONE_OR_TABLET_PATTERN.test(`${userAgent} ${userAgentDataPlatform}`)
  ) {
    return true
  }

  if (/MacIntel/i.test(platform) && navigatorValue.maxTouchPoints > 1) {
    return true
  }

  if (/Linux (arm|aarch64)/i.test(platform) && hasTouch) {
    return true
  }

  return hasTouch && hasCoarsePointer
}
